import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { RootService } from 'src/app/shared/services/root.service';
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-product-rating',
  templateUrl: './product-rating.component.html',
  styleUrls: ['./product-rating.component.scss'],
})
export class ProductRatingComponent implements OnInit {
  environment1 = environment.s3bucket.url;
  heartUrls = {
    empty: '../../../assets/images/Star-unfilled.svg',
    half: '../../../assets/images/Star-unfilled.svg',
    full: '../../../assets/images/Star-filled.svg',
  };
  sub: Subscription = new Subscription();
  @Input() productId: any;
  @Input() productdData:any
  ratingList: any = [];
  closeResult: any;
  productReviewData: any;
  @ViewChild('productReview', { read: TemplateRef })
  productReview!: TemplateRef<any>;
  productDetailList: any;
  safety: number;
  performance: any;
  design: any;
  comfort: any;
  oneStarRatingCount: number;
  twoStarRatingCount: number;
  threeStarRatingCount: number;
  fourStarRatingCount: number;
  fiveStarRatingCount: number;
  totalRating: any;
  overall: any;
  descriptionCount: number;
  vc: any;

  isUserLoggedIn: any;
  userData: any;
  constructor(
    private apiService: ApiService,
    private router: Router,
    private rootService: RootService,
    private modalService: NgbModal,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private behaviorService: BehaviourSubjectService
  ) {

  }

  ngOnInit(): void {
    this.sub.add(
      this.behaviorService.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
        this.userData = this.rootService.getUserData();
      })
    );
    this.sub.add(
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params['dealer']) {
          localStorage.setItem('dealercd', params['dealer']);
          localStorage.setItem('vc', params['vc']);
          this.vc = params['vc'];
          this.getVehicleDetail();
        }
      })
    );
    this.activatedRoute.paramMap.subscribe((params) => {
      if (params.get('id')) {
        this.productId = params.get('id');
        this.getVehicleDetail();
      }
    });

  }
  getReview(data1: any, flag: any) {
    this.sub.add(
      this.apiService.getRatings(data1).subscribe({
        next: (res: any) => {
          if(res.success){
          if (flag == 'view') {
            this.ratingList = res.data;
            this.safety = 0;
            this.performance = 0;
            this.design = 0;
            this.comfort = 0;
            this.overall = 0;
            var overallCount = 0;
            var safetyCount = 0;
            var performanceCount = 0;
            var designCount = 0;
            var comfortCount = 0;
            this.oneStarRatingCount = 0;
            this.twoStarRatingCount = 0;
            this.threeStarRatingCount = 0;
            this.fourStarRatingCount = 0;
            this.fiveStarRatingCount = 0;
            this.totalRating = 0;
            this.descriptionCount = 0;
            if (this.ratingList) {
              for (let i = 0; i < this.ratingList?.length; i++) {
                if (this.ratingList[i].description) {
                  this.descriptionCount += 1;
                }
                for (
                  let j = 0;
                  j < this.ratingList[i].rating_master?.length;
                  j++
                ) {
                  if (
                    this.ratingList[i].rating_master[j].parameter == 'safety'
                  ) {
                    safetyCount += 1;
                    this.safety += this.ratingList[i].rating_master[j].rating;
                    if (i == this.ratingList?.length - 1)
                      this.safety = this.safety / safetyCount;
                  } else if (
                    this.ratingList[i].rating_master[j].parameter ==
                    'performance'
                  ) {
                    performanceCount += 1;
                    this.performance +=
                      this.ratingList[i].rating_master[j].rating;
                    if (i == this.ratingList?.length - 1)
                      this.performance = this.performance / performanceCount;
                  } else if (
                    this.ratingList[i].rating_master[j].parameter == 'design'
                  ) {
                    designCount += 1;
                    this.design += this.ratingList[i].rating_master[j].rating;
                    if (i == this.ratingList?.length - 1)
                      this.design = this.design / designCount;
                  } else if (
                    this.ratingList[i].rating_master[j].parameter == 'comfort'
                  ) {
                    comfortCount += 1;
                    this.comfort += this.ratingList[i].rating_master[j].rating;
                    if (i == this.ratingList?.length - 1)
                      this.comfort = this.comfort / comfortCount;
                  } else if (
                    this.ratingList[i].rating_master[j].parameter == 'overall'
                  ) {
                    overallCount += 1;
                    this.overall += this.ratingList[i].rating_master[j].rating;
                    if (this.ratingList[i].rating_master[j].rating == 1) {
                      this.oneStarRatingCount += 1;
                    } else if (
                      this.ratingList[i].rating_master[j].rating == 2
                    ) {
                      this.twoStarRatingCount += 1;
                    } else if (
                      this.ratingList[i].rating_master[j].rating == 3
                    ) {
                      this.threeStarRatingCount += 1;
                    } else if (
                      this.ratingList[i].rating_master[j].rating == 4
                    ) {
                      this.fourStarRatingCount += 1;
                    } else if (
                      this.ratingList[i].rating_master[j].rating == 5
                    ) {
                      this.fiveStarRatingCount += 1;
                    }
                    if (i == this.ratingList?.length - 1)
                      this.overall = this.overall / overallCount;
                  }
                }
                if (
                  this.oneStarRatingCount > 0 ||
                  this.twoStarRatingCount > 0 ||
                  this.threeStarRatingCount > 0 ||
                  this.fourStarRatingCount > 0 ||
                  this.fiveStarRatingCount
                ) {
                  this.totalRating = this.overall.toFixed(1);
                  } else {
                  this.totalRating = 0;
                }
              }
            }
          } else if (flag == 'write') {
            res.data = res.data;
            if (res.data?.length > 0) {
              var json = {
                overall: res.data[0].rating_master.find((e: any) => {
                  if (e.parameter == 'overall') {
                    return e.rating;
                  }
                }),
                performance: res.data[0].rating_master.find((e: any) => {
                  if (e.parameter == 'performance') {
                    return e.rating;
                  }
                }),
                safety: res.data[0].rating_master.find((e: any) => {
                  if (e.parameter == 'safety') {
                    return e.rating;
                  }
                }),
                comfort: res.data[0].rating_master.find((e: any) => {
                  if (e.parameter == 'comfort') {
                    return e.rating;
                  }
                }),
                design: res.data[0].rating_master.find((e: any) => {
                  if (e.parameter == 'design') {
                    return e.rating;
                  }
                }),
                ratingPresent: true,
                productId: this.productId,
                title: res.data[0].title,
                description: res.data[0].description,
                image: res.data[0].image[0],
                model: this.productdData?.model,
                mainImage: this.productdData?.images[0].image_url,
              };
              this.productReviewData = json;

              this.openPopup();
            } else {
              var json1 = {
                overall: 0,
                performance: 0,
                safety: 0,
                comfort: 0,
                design: 0,
                ratingPresent: false,
                productId: this.productId,
                title: '',
                description: '',
                image: '',
                model: this.productdData?.model,
                mainImage: this.productdData?.images[0].image_url,
              };

              this.productReviewData = json1;
              this.openPopup();
            }
          }}
          else{

          this.toastrService.warning(res.data.msg);
          }
        },
      })
    );
  }

   getVehicleDetail() {
          let data1 = {
            // product_id: this.productdData.id,
            product_id:this.productId,
            action_type: 'product',
          };
          this.getReview(data1, 'view');
  }

  writeReview(flag: any) {
    if (flag == 'view') {
      this.router.navigate(['/rating-review/' + this.productId]);
    } else if (flag == 'write') {
      if(this.isUserLoggedIn) {
        let data = {
          product_id: this.productId,
          action_type: 'product',
          is_customer_rating: true,
        };
        this.getReview(data, 'write');
      } else {
        localStorage.setItem('previousUrl', this.router.url);
        this.router.navigate(['/login/']);
      }
    }
  }

  openPopup() {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: true,
      windowClass: 'side-drawer',
    };
    this.modalService.open(this.productReview, ngbModalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        if (this.closeResult) {
          let data = {
            product_id: this.productId,
            action_type: 'product',
          };
          this.getReview(data, 'view');
        }
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getRatingValue(value) {
    if (this.ratingList?.length && value > 0) {
      let rating = this.ratingList?.length;
      let width = (100 / rating) * value + '%';
      return width;
    } else {
      return 0;
    }
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
